var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.1538C32 27.5916 27.5916 31.9998 22.1538 32H4.75385L5.0625 31.6913C8.01681 28.737 12.0239 27.077 16.2019 27.0769H22.1538C24.8727 27.0768 27.0769 24.8727 27.0769 22.1538V16.2029C27.0769 12.0249 28.7362 8.01784 31.6904 5.06346L32 4.75385V22.1538ZM27.2452 0L26.9365 0.308654C23.9821 3.26301 19.9752 4.92308 15.7971 4.92308H9.84615C7.12721 4.92308 4.92308 7.12721 4.92308 9.84615V15.7971C4.92308 19.9752 3.26301 23.9821 0.308654 26.9365L0 27.2452V9.84615C2.37697e-07 4.40827 4.40827 7.30765e-07 9.84615 0H27.2452Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymb);
export default __webpack_public_path__ + "static/media/symb.74978e28fe12d437292fb7e1396388cb.svg";
export { ForwardRef as ReactComponent };